import React, { Suspense, lazy } from "react";
import "./index.css";

// Lazy load the SwmcFooter component
const SwmcFooter = lazy(() => import("footer-component").then(module => ({ default: module.SwmcFooter })));

const CustomFooter = () => {
  return (
    <Suspense fallback={<div>Loading footer...</div>}>
      <SwmcFooter type="swmc" showTacanewLogo={true} nydisclaimer={false} />
    </Suspense>
  );
};

export default CustomFooter;
